const reducer = (state: any) => ({
  ...state,
  loaded: false,
  waiting: false,
  order: { status: undefined },
});

export default reducer;
